import { useGetShipmentBasic } from "api/queries/shipments/useGetShipmentBasic";
import Export from "./Export";
import Menu from "./Menu";

interface CommonActionIconButtonsProps {
  isQuickRequest: boolean;
  shipmentId: string;
  tabTitle: string;
}

export default function CommonActionIconButtons({ isQuickRequest, shipmentId, tabTitle }: CommonActionIconButtonsProps) {
  const { data: shipmentBasicData }: any = useGetShipmentBasic(shipmentId, {
    enabled: !isQuickRequest && !!shipmentId,
    refetchOnMount: false,
  });

  const { shipment } = shipmentBasicData || {};
  const isOffPlatform = shipment?.is_off_platform_shipment || false;

  // Export dropdown is shown for non-quick, non-off-platform requests
  const showExportDropdown = !isQuickRequest && !isOffPlatform;

  return (
    <>
      {/* Export dropdown */}
      {showExportDropdown && <Export />}

      {/* More options menu */}
      <Menu isQuickRequest={isQuickRequest} shipmentId={shipmentId} tabTitle={tabTitle} />
    </>
  );
}
